import { render, staticRenderFns } from "./ArrowNavigation.vue?vue&type=template&id=39b38504&lang=pug&"
import script from "./ArrowNavigation.vue?vue&type=script&lang=ts&"
export * from "./ArrowNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b38504')) {
      api.createRecord('39b38504', component.options)
    } else {
      api.reload('39b38504', component.options)
    }
    module.hot.accept("./ArrowNavigation.vue?vue&type=template&id=39b38504&lang=pug&", function () {
      api.rerender('39b38504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ArrowNavigation.vue"
export default component.exports